import { Component, Vue } from 'vue-property-decorator'

@Component({
  template: require('template/disclaimer.html'),
  components: {}
})
export default class Disclaimer extends Vue {
}
